import { FC } from "react"
import { ISupply } from "../../../app/reducers/ordersReducer"
import { FormKatrenOrder } from "../FormKatrenOrder"
import { getWBOrdersForKatren } from "./utils"

type FormWBKatrenOrderProps = {
  selectedSupplies: ISupply[]
  name?: string
}

export const FormWBKatrenOrder: FC<FormWBKatrenOrderProps> = ({
  name,
  selectedSupplies,
}) => {
  return (
    <FormKatrenOrder
      isDisabled={
        !selectedSupplies?.length ||
        !selectedSupplies?.some((supply) => !!supply.orders?.length)
      }
      getOrdersForKatren={() => getWBOrdersForKatren(selectedSupplies || [])}
      name={name}
      supplies={selectedSupplies || []}
    />
  )
}
